// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'arrow-left';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M15 9H2m6.067-6L2 9l6.067 6'
  />
);

export const viewBox = '0 0 18 18';
